import { DATE_FORMATS } from "../../../../constants/date/date.js";
import { useMutation } from "@tanstack/react-query";
import { add, format } from "date-fns";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "react";
import "axios";
const setServerErrors = (form) => (formError) => {
  var _a, _b;
  const formErrors = (_b = (_a = formError == null ? void 0 : formError.response) == null ? void 0 : _a.data) == null ? void 0 : _b.fields;
  formErrors == null ? void 0 : formErrors.forEach((error) => {
    if (error.field && error.message)
      form.setError(error.field, { message: error.message });
  });
};
const editAppointment = (axios) => async (appointmentReferenceId, params) => {
  const { data } = await axios.put(
    `/api/v1/internal/appointments/${appointmentReferenceId ?? ""}`,
    params
  );
  return data;
};
const saveAppointment = (axios) => async (params, isOpenAppointment) => {
  const url = isOpenAppointment ? "/api/v1/internal/open-appointments/" : "/api/v1/internal/appointments/";
  const { data } = await axios.post(url, params);
  return data;
};
const useSaveAppointment = ({ clinicReferenceId, form, isOpenAppointment }) => {
  const { echoCore } = useAxiosProvider();
  const mutation = useMutation({
    ...form && {
      onError: setServerErrors(form)
    },
    mutationFn: ({ data }) => {
      const {
        referenceId,
        employeeReferenceId,
        randomPractitioner,
        patientReferenceId,
        startTime,
        duration,
        patient,
        treatmentReferenceId,
        openedForOnlineBooking,
        overbooked,
        employeeByRole,
        ...rest
      } = data;
      const requestData = {
        ...rest,
        clinicReferenceId,
        practitionerReferenceId: employeeReferenceId || randomPractitioner,
        blocking: !openedForOnlineBooking,
        allowOverbooked: !!overbooked,
        ...!!patientReferenceId && {
          patientReferenceId
        },
        ...startTime && {
          start: new Date(startTime)
        },
        ...startTime && duration && typeof duration === "number" && {
          end: add(new Date(startTime), { minutes: duration })
        },
        ...duration === null && {
          treatmentBundleReferenceId: treatmentReferenceId
        },
        ...duration !== null && {
          durationInMinutes: duration,
          treatmentReferenceId
        },
        ...!employeeReferenceId && !randomPractitioner && {
          employeeByRole
        },
        ...patient && !patientReferenceId && {
          patient: {
            ...patient,
            email: patient.email ? patient.email : void 0,
            gender: patient.genderType,
            clinicReferenceId,
            ...patient.dateOfBirth && {
              dateOfBirth: format(patient.dateOfBirth, DATE_FORMATS.ISO_SHORT)
            }
          }
        }
      };
      if (referenceId) {
        return editAppointment(echoCore)(referenceId, requestData);
      }
      return saveAppointment(echoCore)(requestData, isOpenAppointment);
    }
  });
  return mutation;
};
export {
  setServerErrors,
  useSaveAppointment
};
